'use strict';
var PagingController = /** @class */ (function () {
    /*@ngInject*/
    function PagingController($scope, $location, $anchorScroll, $timeout) {
        var self = this;
        self.$location = $location;
        self.$anchorScroll = $anchorScroll;
        self.$timeout = $timeout;
    }
    //called from the select in the template. The select sets the current page value so we just need to call pageChanged
    PagingController.prototype.setPage = function () {
        this.$location.hash('main');
        this.$anchorScroll();
        this.$timeout(this.pageChanged, 500); // a moment to display new data before potential scrolling in pageChanged
    };
    ;
    PagingController.prototype.setPagePrevious = function () {
        //we can't go back any further so return.
        if (this.pageModel.currentPage === 1) {
            return;
        }
        this.pageModel.currentPage -= 1;
        this.pageChanged(); //Call out to let the parent do any page action necessary
    };
    ;
    PagingController.prototype.setPageNext = function () {
        //we can't go any further so return out
        if (this.pageModel.currentPage === this.pageModel.currentPage.totalPages) {
            return;
        }
        this.pageModel.currentPage += 1;
        this.pageChanged(); //Call out to let the parent do any page action necessary
    };
    ;
    return PagingController;
}());
export default PagingController;
//# sourceMappingURL=paging.controller.js.map